export const formatRouteTag = (routeId?: string, fallbackIndex?: number): string => {
    if (routeId && routeId.startsWith('cluster_')) {
        const n = Number(routeId.replace('cluster_', ''));
        if (!Number.isNaN(n)) return `R-${String(n + 1).padStart(2, '0')}`;
    }

    if (routeId) {
        const compact = routeId.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        if (compact.length >= 4) return `R-${compact.slice(-4)}`;
        if (compact.length > 0) return `R-${compact}`;
    }

    if (typeof fallbackIndex === 'number' && fallbackIndex >= 0) {
        return `R-${String(fallbackIndex + 1).padStart(2, '0')}`;
    }

    return 'R-?';
};

export const getFleetLabel = (mode: 'own' | 'third'): string =>
    mode === 'own' ? 'FROTA PROPRIA' : 'APP TERCEIRO';
